export default __webpack_public_path__ + "static/media/fsi1.b7350a5d.gif";